import { IncomingMessage } from 'http'
import { Iata, SupportedLocale } from '../schemas'
import { getWhitelabelOpCoForHost } from '../utils/whitelabel'
import { getPlatformConfigFromCookies } from '../utils/aviosCookies'

export const getOpCoFromRequest = (request: IncomingMessage): Iata => {
  const requestHost = request.headers.host
  const maybeWhitelabelOpCo = getWhitelabelOpCoForHost(requestHost)
  if (maybeWhitelabelOpCo) {
    return maybeWhitelabelOpCo
  }

  const cookies = request.headers.cookie ?? ''
  const { opCo } = getPlatformConfigFromCookies(cookies)

  return opCo
}

export const getOpCoDefaultLocaleFromRequest = (request: IncomingMessage): SupportedLocale => {
  const requestHost = request.headers.host
  const maybeWhitelabelOpCo = getWhitelabelOpCoForHost(requestHost)
  if (maybeWhitelabelOpCo) {
    return 'en-GB'
  }

  const cookies = request.headers.cookie ?? ''
  const { locale } = getPlatformConfigFromCookies(cookies)
  return locale
}
